import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlashMapHelpTranslations, FLASH_MAP_TRANSLATIONS } from '../../i18n/flash-map-i18n';

export type HelpShortcut = { keys: string[]; label: string };
export type HelpShortcutGroup = {
  title: string;
  shortcuts: HelpShortcut[];
  desktopColumn?: 'left' | 'right';
};

@Component({
  selector: 'lib-help-shortcuts',
  templateUrl: './help-shortcuts.component.html',
  styleUrls: ['./help-shortcuts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class HelpShortcutsComponent {
  readonly open = input(false);
  readonly title = input('');
  readonly groups = input<HelpShortcutGroup[]>([]);
  readonly translations = input<FlashMapHelpTranslations>(FLASH_MAP_TRANSLATIONS.en.help);

  readonly desktopColumns = computed(() => {
    const groups = this.groups();
    const fallbackLeftCount = Math.ceil(groups.length / 2);
    const left: HelpShortcutGroup[] = [];
    const right: HelpShortcutGroup[] = [];

    groups.forEach((group, index) => {
      if (group.desktopColumn === 'right' || (!group.desktopColumn && index >= fallbackLeftCount)) {
        right.push(group);
        return;
      }

      left.push(group);
    });

    return { left, right };
  });

  readonly close = output<void>();

  trackByGroup(index: number, group: HelpShortcutGroup): string {
    return `${group.title}|${index}`;
  }

  trackByShortcut(index: number, shortcut: HelpShortcut): string {
    return `${shortcut.label}|${shortcut.keys.join('+')}`;
  }

  splitCombo(combo: string): string[] {
    return combo
      .split('+')
      .map(part => part.trim())
      .filter(Boolean);
  }

  onBackdropClick(): void {
    this.close.emit();
  }

  onCloseClick(): void {
    this.close.emit();
  }
}

